import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ObterConteudoCadernoPorIdState } from "../../reducers/Caderno/obter-conteudo-caderno-por-id.reducer";

export const selectObterConteudoCadernoPorIdState = createFeatureSelector<ObterConteudoCadernoPorIdState>('obterConteudoCadernoPorId');

export const selectDadosObterConteudoCadernoPorId = createSelector(
    selectObterConteudoCadernoPorIdState,
    (state: ObterConteudoCadernoPorIdState) => state.response
);

export const selectObterConteudoCadernoPorId = createSelector(
  selectObterConteudoCadernoPorIdState,
  (state: ObterConteudoCadernoPorIdState) => state
);

export const selectErrosObterConteudoCadernoPorId = createSelector(
    selectObterConteudoCadernoPorIdState,
    (state: ObterConteudoCadernoPorIdState) => state.error
);